/**
 * Dates SAISIES dans les formulaires publics (champ « date » des adhésions,
 * de la billetterie, de la boutique) : stockées en ISO `AAAA-MM-JJ`,
 * affichées et tapées en `JJ/MM/AAAA`.
 *
 * 🔴 SANS FUSEAU HORAIRE (Karim 2026-09-29). La vérification construisait
 * minuit en heure LOCALE (`new Date("2026-09-11T00:00:00")`) puis le relisait
 * en heure UNIVERSELLE (`getUTCDate`) : en France (UTC+1 ou +2), minuit le 11
 * est encore le 10 en UTC — TOUTE date était refusée (« Date invalide.
 * Format attendu : JJ/MM/AAAA », sur « 11/09/2026 » choisi dans le
 * calendrier). Les adhérents d'Elite Pétanque ne pouvaient plus passer
 * l'étape « date de naissance du joueur ». Ici, tout se calcule en UTC.
 */

/** Date ISO `AAAA-MM-JJ` réellement existante (rejette le 31/02, le 13e mois). */
export function dateIsoExiste(iso: string): boolean {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  if (!m) return false;
  const annee = Number(m[1]);
  const mois = Number(m[2]);
  const jour = Number(m[3]);
  if (mois < 1 || mois > 12 || jour < 1) return false;
  const d = new Date(Date.UTC(annee, mois - 1, jour));
  return (
    d.getUTCFullYear() === annee &&
    d.getUTCMonth() === mois - 1 &&
    d.getUTCDate() === jour
  );
}

/** `JJ/MM/AAAA` tapé → ISO `AAAA-MM-JJ`, ou `undefined` si la date n'existe pas. */
export function texteVersDateIso(texte: string): string | undefined {
  const m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(texte);
  if (!m) return undefined;
  const iso = `${m[3]}-${m[2]}-${m[1]}`;
  return dateIsoExiste(iso) ? iso : undefined;
}

/** ISO `AAAA-MM-JJ` → `JJ/MM/AAAA` (vide si la valeur n'en est pas une). */
export function dateIsoVersTexte(iso: string | undefined): string {
  if (!iso) return "";
  const [a, m, j] = iso.split("-");
  return a && m && j ? `${j}/${m}/${a}` : "";
}
